import { InternalAxiosRequestConfig } from 'axios'
import uuid from 'react-uuid'
import { User } from 'src/helpers'

const tdcUrl = process.env.REACT_APP_API.toString()

export function customHeadersTDC(config: InternalAxiosRequestConfig) {
  const isTdcBaseURL = config.baseURL === tdcUrl
  const urlIncludesTdc = config.url?.includes(tdcUrl)

  if (isTdcBaseURL || urlIncludesTdc) {
    config.headers['x-user-id'] = User.getInstance().getUserId() as string
    config.headers['x-correlation-id'] = uuid()
  }

  return config
}
